export type ViewConfig = {
  showTopNav?: boolean;
  showBackButton?: boolean;
  showTitle?: boolean;
  showCloseButton?: boolean;
  showDivider?: boolean;
  disableStickyNav?: boolean;
  titleText?: string;
  showLogo?: boolean;
};

export const DEFAULT_VIEW_CONFIG: ViewConfig = {
  showBackButton: true,
  showCloseButton: true,
  showTitle: true,
  showTopNav: true,
  showDivider: true,
  disableStickyNav: false,
  showLogo: false,
} as const;
